import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 100 100">
    <title>Gurudatta Logo</title>
    <g transform="translate(3.5, 0)">
      <path
        id="glyph"
        d="M 48, 28 C 35, 28 25, 38 25, 50 C 25, 62 35, 72 48, 72 C 58, 72 65, 66 68, 58 L 68, 58 L 68, 46 L 46, 46 L 46, 54 L 59, 54 C 58, 59 54, 64 48, 64 C 40, 64 34, 58 34, 50 C 34, 42 40, 36 48, 36 C 52, 36 55, 38 57, 40 L 63, 34 C 59, 30 54, 28 48, 28 Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default IconLogo;
